import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createBlock as _createBlock, Fragment as _Fragment, withCtx as _withCtx, Transition as _Transition, vModelSelect as _vModelSelect, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "wrapper" }
const _hoisted_2 = { class: "container-grid" }
const _hoisted_3 = { class: "content-header pl-5" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_5 = {
  id: "buttons-container",
  class: "d-flex card-title",
  style: {"height":"2rem","margin-top":"35px"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  style: {"width":"75px"}
}
const _hoisted_11 = {
  key: 1,
  style: {"width":"100px"}
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 1,
  style: {"width":"100px"}
}
const _hoisted_15 = {
  key: 0,
  class: "fullscreen-div"
}
const _hoisted_16 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block"}
}
const _hoisted_17 = {
  class: "modal-dialog modal-lg",
  style: {"max-width":"1200px"}
}
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = { class: "modal-header" }
const _hoisted_20 = {
  key: 0,
  class: "modal-title"
}
const _hoisted_21 = { class: "modal-body" }
const _hoisted_22 = {
  style: {"background-color":"#fff"},
  class: "p-3 d-flex mt-2 justify-content-between"
}
const _hoisted_23 = {
  class: "p-3 info-container",
  style: {"width":"29%"}
}
const _hoisted_24 = { class: "d-flex" }
const _hoisted_25 = { class: "d-flex" }
const _hoisted_26 = { class: "d-flex" }
const _hoisted_27 = { class: "d-flex" }
const _hoisted_28 = { class: "d-flex" }
const _hoisted_29 = { class: "d-flex" }
const _hoisted_30 = { class: "d-flex" }
const _hoisted_31 = {
  id: "2nd-column",
  style: {"width":"29%"}
}
const _hoisted_32 = {
  class: "p-3 info-container w-100 mb-4",
  id: "2nd-column-container"
}
const _hoisted_33 = { class: "d-flex" }
const _hoisted_34 = { class: "d-flex" }
const _hoisted_35 = { class: "d-flex" }
const _hoisted_36 = { class: "d-flex" }
const _hoisted_37 = { class: "p-3 info-container w-100" }
const _hoisted_38 = { class: "d-flex" }
const _hoisted_39 = { class: "d-flex mb-2" }
const _hoisted_40 = { class: "d-flex" }
const _hoisted_41 = { class: "d-flex" }
const _hoisted_42 = { class: "d-flex align-items-start" }
const _hoisted_43 = {
  class: "p-3 info-container",
  style: {"width":"40%"}
}
const _hoisted_44 = { class: "d-flex" }
const _hoisted_45 = { class: "d-flex" }
const _hoisted_46 = { class: "d-flex" }
const _hoisted_47 = { class: "d-flex" }
const _hoisted_48 = { class: "d-flex" }
const _hoisted_49 = { class: "d-flex" }
const _hoisted_50 = { class: "d-flex" }
const _hoisted_51 = {
  class: "modal-footer justify-content-between",
  id: "responsive-footer"
}
const _hoisted_52 = {
  id: "text-container",
  style: {"width":"80%"}
}
const _hoisted_53 = { class: "font-weight-bold p-0 m-0" }
const _hoisted_54 = {
  id: "buttons-container",
  style: {"width":"15%"}
}
const _hoisted_55 = ["disabled"]
const _hoisted_56 = {
  key: 1,
  class: "modal fade show",
  style: {"display":"block"}
}
const _hoisted_57 = { class: "modal-dialog modal-lg" }
const _hoisted_58 = { class: "modal-content" }
const _hoisted_59 = { class: "modal-header" }
const _hoisted_60 = { class: "modal-title" }
const _hoisted_61 = { class: "modal-body" }
const _hoisted_62 = {
  id: "reclassification-container",
  class: "d-flex"
}
const _hoisted_63 = { class: "modal-footer justify-content-between" }
const _hoisted_64 = {
  key: 2,
  class: "modal fade show",
  style: {"z-index":"9999","display":"block"}
}
const _hoisted_65 = { class: "modal-dialog modal-md" }
const _hoisted_66 = { class: "modal-content" }
const _hoisted_67 = { class: "modal-header" }
const _hoisted_68 = { class: "modal-title" }
const _hoisted_69 = { class: "modal-body" }
const _hoisted_70 = { class: "modal-footer justify-content-between" }
const _hoisted_71 = {
  key: 3,
  class: "modal fade show",
  style: {"display":"block"}
}
const _hoisted_72 = { class: "modal-dialog modal-lg" }
const _hoisted_73 = { class: "modal-content" }
const _hoisted_74 = { class: "modal-body" }
const _hoisted_75 = { class: "modal-title" }
const _hoisted_76 = { class: "modal-footer justify-content-between" }

export function render(_ctx, _cache) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_table_lite = _resolveComponent("table-lite")
  const _component_b_tab = _resolveComponent("b-tab")
  const _component_b_tabs = _resolveComponent("b-tabs")
  const _component_model_select = _resolveComponent("model-select")
  const _directive_tooltip = _resolveDirective("tooltip")
  const _directive_maska = _resolveDirective("maska")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[49] || (_cache[49] = _createStaticVNode("<div class=\"container-fluid\"><div class=\"row\"><div class=\"col d-flex flex-column align-items-center\"><h1 style=\"font-size:2.5rem;\">Causa Básica Y10-Y34</h1><h4 class=\"mt-1\">Óbitos linkados</h4></div></div></div>", 1)),
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "btn btn-primary btn-sm mr-1 d-flex align-items-center",
                onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.viewFilters && _ctx.viewFilters(...args)))
              }, _cache[46] || (_cache[46] = [
                _createElementVNode("i", { class: "fas fa-filter mr-2" }, null, -1),
                _createTextVNode(" Filtrar ")
              ])),
              _createElementVNode("button", {
                class: "btn btn-success btn-sm mr-1",
                onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
              }, "Aplicar filtros"),
              _createElementVNode("button", {
                class: "btn btn-secondary btn-sm mr-1",
                onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
              }, "Limpar filtros"),
              _createElementVNode("button", {
                class: "btn btn-info btn-sm",
                onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.exportCSV && _ctx.exportCSV(...args)))
              }, "Exportar CSV")
            ])
          ])
        ]),
        _createVNode(_component_table_lite, {
          rows: _ctx.table.rows,
          columns: _ctx.table.columns,
          sortable: _ctx.table.sortable,
          "is-slot-mode": true,
          pageSize: _ctx.perPage,
          page: _ctx.currentPage,
          pageOptions: _ctx.table.pageOptions,
          total: _ctx.table.totalRecordCount,
          onDoSearch: _ctx.doSearch
        }, {
          actions: _withCtx((props) => [
            (props.value?.numDO !== -1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-success",
                    style: {"color":"#fff"},
                    onClick: $event => (_ctx.openModal({ modal: 'modalRegister', data: props.value }))
                  }, _cache[47] || (_cache[47] = [
                    _createElementVNode("i", { class: "fas fa-search" }, null, -1)
                  ]), 8, _hoisted_7)
                ]))
              : _createCommentVNode("", true)
          ]),
          status: _withCtx((props) => [
            (_ctx.showFilters && props.value?.status === -1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_MultiSelect, {
                    modelValue: _ctx.filters.status,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.filters.status) = $event)),
                    options: _ctx.statusOptions,
                    optionLabel: "name",
                    class: "border bg-white",
                    style: {"width":"67px"}
                  }, null, 8, ["modelValue", "options"])
                ]))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["fw-bold rounded px-1", {
            'bg-danger': ![1, 2].includes(props.value.status),
            'bg-warning': props.value.status === 1,
            'bg-success': props.value.status === 2,
            'text-white': props.value.status === 2,
          }])
                }, _toDisplayString(_ctx.statusEnum[props.value.status ?? 0]), 3))
          ]),
          concordaReclassificacao: _withCtx((props) => [
            (_ctx.showFilters && props.value?.concordaReclassificacao === -1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_MultiSelect, {
                    modelValue: _ctx.filters.concordaReclassificacao,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.filters.concordaReclassificacao) = $event)),
                    options: _ctx.concordanciaOptions,
                    optionLabel: "name",
                    class: "border bg-white",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue", "options"])
                ]))
              : _withDirectives((_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["fw-bold rounded px-1", {
            'bg-danger': props.value.concordaReclassificacao === false,
            'bg-success': props.value.concordaReclassificacao === true,
          }])
                }, [
                  _createTextVNode(_toDisplayString(_ctx.concordaEnum[props.value.concordaReclassificacao ?? ""]), 1)
                ], 2)), [
                  [_directive_tooltip, props.value.causaBasicaReclassificadaDesc]
                ])
          ]),
          numDO: _withCtx((props) => [
            (_ctx.showFilters && props.value?.numDO === -1)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.filters.numDO) = $event)),
                  style: {"width":"75px"},
                  onKeydown: _cache[7] || (_cache[7] = _withKeys((...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["enter"]))
                }, null, 544)), [
                  [_vModelText, _ctx.filters.numDO]
                ])
              : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(props.value.numDO), 1))
          ]),
          sexo: _withCtx((props) => [
            (_ctx.showFilters && props.value?.sexo === -1)
              ? (_openBlock(), _createBlock(_component_MultiSelect, {
                  key: 0,
                  modelValue: _ctx.filters.sexo,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.filters.sexo) = $event)),
                  options: _ctx.sexoOptions,
                  optionLabel: "name",
                  class: "border bg-white",
                  style: {"width":"60px"}
                }, null, 8, ["modelValue", "options"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(props.value.sexo), 1)
                ], 64))
          ]),
          idadeObito: _withCtx((props) => [
            (_ctx.showFilters && props.value?.idadeObito === -1)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.filters.idadeObito) = $event)),
                  style: {"width":"60px"},
                  onKeydown: _cache[10] || (_cache[10] = _withKeys((...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["enter"]))
                }, null, 544)), [
                  [_vModelText, _ctx.filters.idadeObito]
                ])
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(props.value.idadeObito), 1)
                ], 64))
          ]),
          ufResidencia: _withCtx((props) => [
            (_ctx.showFilters && props.value?.ufResidencia === -1)
              ? (_openBlock(), _createBlock(_component_MultiSelect, {
                  key: 0,
                  modelValue: _ctx.filters.ufResidencia,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.filters.ufResidencia) = $event)),
                  options: _ctx.ufOptions,
                  optionLabel: "code",
                  class: "border bg-white",
                  style: {"width":"45px"}
                }, null, 8, ["modelValue", "options"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(props.value.ufResidencia), 1)
                ], 64))
          ]),
          codigoMunicipioResidencia: _withCtx((props) => [
            (_ctx.showFilters && props.value?.codigoMunicipioResidencia === -1)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.filters.codigoMunicipioResidencia) = $event)),
                  onKeydown: _cache[13] || (_cache[13] = _withKeys((...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["enter"]))
                }, null, 544)), [
                  [_vModelText, _ctx.filters.codigoMunicipioResidencia]
                ])
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(props.value.codigoMunicipioResidencia), 1)
                ], 64))
          ]),
          dataObito: _withCtx((props) => [
            (_ctx.showFilters && props.value?.dataObito === -1)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.filters.dataObito) = $event)),
                  "data-maska": "##/##/####",
                  placeholder: "DD/MM/AAAA",
                  class: "form-control form-control-sm",
                  style: {"width":"100px"},
                  onKeydown: _cache[15] || (_cache[15] = _withKeys((...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["enter"]))
                }, null, 544)), [
                  [_vModelText, _ctx.filters.dataObito],
                  [_directive_maska]
                ])
              : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(props.value.dataObito), 1))
          ]),
          acidenteTrabalho: _withCtx((props) => [
            (_ctx.showFilters && props.value?.acidenteTrabalho === -1)
              ? (_openBlock(), _createBlock(_component_MultiSelect, {
                  key: 0,
                  modelValue: _ctx.filters.acidenteTrabalho,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.filters.acidenteTrabalho) = $event)),
                  options: _ctx.acidTrabOptions,
                  optionLabel: "name",
                  class: "border bg-white",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue", "options"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(props.value.acidenteTrabalhoRevisado || props.value.acidenteTrabalho || '-'), 1)
                ], 64))
          ]),
          codigoCausaBasica: _withCtx((props) => [
            (_ctx.showFilters && props.value?.causaBasica === -1)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => ((_ctx.filters.causaBasica) = $event)),
                  onKeydown: _cache[18] || (_cache[18] = _withKeys((...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["enter"]))
                }, null, 544)), [
                  [_vModelText, _ctx.filters.causaBasica]
                ])
              : _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString(props.value.codigoCausaBasica || '-'), 1)
                ])), [
                  [_directive_tooltip, props.value.causaBasica]
                ])
          ]),
          codigoCausaBasicaReclassificada: _withCtx((props) => [
            (_ctx.showFilters && props.value?.causaBasicaReclassificada === -1)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => ((_ctx.filters.causaBasicaReclassificada) = $event)),
                  onKeydown: _cache[20] || (_cache[20] = _withKeys((...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["enter"]))
                }, null, 544)), [
                  [_vModelText, _ctx.filters.causaBasicaReclassificada]
                ])
              : _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _createTextVNode(_toDisplayString(props.value.codigoCausaBasicaReclassificada || '-'), 1)
                ])), [
                  [_directive_tooltip, props.value.causaBasicaReclassificada]
                ])
          ]),
          tipoObito: _withCtx((props) => [
            (_ctx.showFilters && props.value?.tipoObito === -1)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((_ctx.filters.tipoObito) = $event)),
                  onKeydown: _cache[22] || (_cache[22] = _withKeys((...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["enter"]))
                }, null, 544)), [
                  [_vModelText, _ctx.filters.tipoObito]
                ])
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(props.value.tipoObitoRevisado || props.value.tipoObito || '-'), 1)
                ], 64))
          ]),
          dataRevisao: _withCtx((props) => [
            (_ctx.showFilters && props.value?.dataRevisao === -1)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => ((_ctx.filters.dataRevisao) = $event)),
                  "data-maska": "##/##/####",
                  placeholder: "DD/MM/AAAA",
                  class: "form-control form-control-sm",
                  style: {"width":"100px"},
                  onKeydown: _cache[24] || (_cache[24] = _withKeys((...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["enter"]))
                }, null, 544)), [
                  [_vModelText, _ctx.filters.dataRevisao],
                  [_directive_maska]
                ])
              : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(props.value.dataRevisao), 1))
          ]),
          _: 1
        }, 8, ["rows", "columns", "sortable", "pageSize", "page", "pageOptions", "total", "onDoSearch"]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.isLoading > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[48] || (_cache[48] = [
                  _createElementVNode("div", { style: {"transform":"translate(-50%, -50%)","font-size":"1.8rem"} }, [
                    _createElementVNode("div", {
                      class: "spinner-border text-primary",
                      role: "status"
                    })
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.modalRegister.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (_ctx.selectedRow)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_20, "DO " + _toDisplayString(_ctx.selectedRow.numDO) + " - " + _toDisplayString(_ctx.selectedRow.sex) + " - Residência em " + _toDisplayString(_ctx.selectedRow.city) + " - " + _toDisplayString(_ctx.selectedRow.state) + " - " + _toDisplayString(_ctx.selectedRow.age) + " anos - Óbito em " + _toDisplayString(_ctx.selectedRow.deathDate), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  "aria-label": "Fechar",
                  onClick: _cache[25] || (_cache[25] = $event => (_ctx.closeModal('modalRegister')))
                }, _cache[50] || (_cache[50] = [
                  _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_b_tabs, {
                  fill: "",
                  "active-nav-item-class": "font-weight-bold text-uppercase text-success"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_tab, { title: "Óbito" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _cache[58] || (_cache[58] = _createElementVNode("h2", { class: "font-weight-bold" }, [
                              _createElementVNode("span", null, "IDENTIFICAÇÃO")
                            ], -1)),
                            _createElementVNode("div", _hoisted_24, [
                              _cache[51] || (_cache[51] = _createElementVNode("label", null, "Número DO:  ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.registro.numDO), 1)
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _cache[52] || (_cache[52] = _createElementVNode("label", null, "Data Óbito:  ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.registro.dataObito), 1)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _cache[53] || (_cache[53] = _createElementVNode("label", null, "UF Ocorrência:  ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.registro.codigoEstabelecimentoOcorrencia), 1)
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _cache[54] || (_cache[54] = _createElementVNode("label", null, "Município Ocorrência:  ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.registro.codigoMunicipioOcorrencia), 1)
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _cache[55] || (_cache[55] = _createElementVNode("label", null, "UF Residência:  ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.registro.ufResidencia), 1)
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _cache[56] || (_cache[56] = _createElementVNode("label", null, "Município Residência:  ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.registro.codigoMunicipioResidencia), 1)
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _cache[57] || (_cache[57] = _createElementVNode("label", null, "Local Ocorrência:  ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.registro.localOcorrencia), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _cache[62] || (_cache[62] = _createElementVNode("h2", { class: "font-weight-bold" }, [
                                _createElementVNode("span", null, "CARACTERIZAÇÃO")
                              ], -1)),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_33, [
                                  _cache[59] || (_cache[59] = _createElementVNode("label", null, "Sexo:  ", -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.registro.sexo), 1)
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                  _cache[60] || (_cache[60] = _createElementVNode("label", null, "Idade:  ", -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.registro.idade), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _cache[61] || (_cache[61] = _createElementVNode("label", null, "Raça/Cor:  ", -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.registro.racaCor), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _cache[70] || (_cache[70] = _createElementVNode("h2", { class: "font-weight-bold" }, [
                                _createElementVNode("span", null, "CAUSAS EXTERNAS")
                              ], -1)),
                              _createElementVNode("div", _hoisted_38, [
                                _cache[63] || (_cache[63] = _createElementVNode("label", null, "Tipo óbito não natural:  ", -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.registro.tipoObito || "-"), 1)
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                _cache[65] || (_cache[65] = _createElementVNode("div", { class: "f-flex flex-column" }, [
                                  _createElementVNode("label", null, [
                                    _createTextVNode("Tipo óbito não natural:  "),
                                    _createElementVNode("br"),
                                    _createElementVNode("span", { style: {"margin-left":"4.5rem"} }, "(revisado)")
                                  ])
                                ], -1)),
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => ((_ctx.registro.tipoObitoRevisado) = $event)),
                                  class: "w-50",
                                  style: {"height":"1.8rem"},
                                  onChange: _cache[27] || (_cache[27] = $event => {_ctx.openModal({
                        modal: 'modalConfirm',
                        title: `Confirma a alteração do tipo óbito não natural para '${_ctx.registro.tipoObitoRevisado}'?`,
                        action: () => _ctx.setDeathTypeReviewed(),
                        actionCancel: () => {
                          _ctx.registro.tipoObitoRevisado = _ctx.registro.tipoObitoRevisadoOriginal;
                          _ctx.closeModal('modalConfirm');
                        },
                      })})
                                }, _cache[64] || (_cache[64] = [
                                  _createElementVNode("option", { value: "9 - Ignorado" }, "Ignorado", -1),
                                  _createElementVNode("option", { value: "1 - Acidente" }, "Acidente", -1),
                                  _createElementVNode("option", { value: "2 - Suicídio" }, "Suicídio", -1),
                                  _createElementVNode("option", { value: "3 - Homicídio" }, "Homicídio", -1),
                                  _createElementVNode("option", { value: "4 - Outros" }, "Outros", -1)
                                ]), 544), [
                                  [_vModelSelect, _ctx.registro.tipoObitoRevisado]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_40, [
                                _cache[66] || (_cache[66] = _createElementVNode("label", null, "Acidente Trabalho?:  ", -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.registro.acidenteTrabalho || "-"), 1)
                              ]),
                              _createElementVNode("div", _hoisted_41, [
                                _cache[68] || (_cache[68] = _createElementVNode("div", { class: "f-flex flex-column" }, [
                                  _createElementVNode("label", null, [
                                    _createTextVNode("Acidente Trabalho?:   "),
                                    _createElementVNode("br"),
                                    _createElementVNode("span", { style: {"margin-left":"4rem"} }, "(revisado)")
                                  ])
                                ], -1)),
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => ((_ctx.registro.acidenteTrabalhoRevisado) = $event)),
                                  class: "w-50",
                                  style: {"height":"1.8rem"},
                                  onChange: _cache[29] || (_cache[29] = $event => {_ctx.openModal({
                        modal: 'modalConfirm',
                        title: `Confirma a alteração de Acidente Trabalho para '${_ctx.registro.acidenteTrabalhoRevisado}'?`,
                        action: () => _ctx.setWorkAccidentReviewed(),
                        actionCancel: () => {
                          _ctx.registro.acidenteTrabalhoRevisado = _ctx.registro.acidenteTrabalhoRevisadoOriginal;
                          _ctx.closeModal('modalConfirm');
                        },
                      })})
                                }, _cache[67] || (_cache[67] = [
                                  _createElementVNode("option", { value: "Ignorado" }, "Ignorado", -1),
                                  _createElementVNode("option", { value: "Sim" }, "Sim", -1),
                                  _createElementVNode("option", { value: "Não" }, "Não", -1)
                                ]), 544), [
                                  [_vModelSelect, _ctx.registro.acidenteTrabalhoRevisado]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                _cache[69] || (_cache[69] = _createElementVNode("label", { style: {"min-width":"140px"} }, "Descrição do evento:", -1)),
                                _createElementVNode("p", null, _toDisplayString(_ctx.registro.dsEvento || "-"), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _cache[78] || (_cache[78] = _createElementVNode("h2", { class: "font-weight-bold" }, [
                              _createElementVNode("span", null, "ATESTADO")
                            ], -1)),
                            _createElementVNode("div", _hoisted_44, [
                              _cache[71] || (_cache[71] = _createElementVNode("label", null, "Linha A:  ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.registro.linhaA), 1)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _cache[72] || (_cache[72] = _createElementVNode("label", null, "Linha B:  ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.registro.linhaB), 1)
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _cache[73] || (_cache[73] = _createElementVNode("label", null, "Linha C:  ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.registro.linhaC), 1)
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _cache[74] || (_cache[74] = _createElementVNode("label", null, "Linha D:  ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.registro.linhaD), 1)
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _cache[75] || (_cache[75] = _createElementVNode("label", null, "Linha II:  ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.registro.linhaII), 1)
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _cache[76] || (_cache[76] = _createElementVNode("label", null, "Causa Básica:  ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.registro.codigoCausaBasica ? `${_ctx.registro.codigoCausaBasica} - ${_ctx.registro.causaBasica}` : '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                              _cache[77] || (_cache[77] = _createElementVNode("label", null, "Causa Básica Original:  ", -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.registro.codigoCausaBasicaOriginal ? `${_ctx.registro.codigoCausaBasicaOriginal} - ${_ctx.registro.causaBasicaOriginal}` : '-'), 1)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_tab, {
                      title: "Internação",
                      class: "mt-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_table_lite, {
                          style: {"font-size":".7rem"},
                          rows: _ctx.registro.internacoes,
                          columns: _ctx.table.multiPageTableColumns.internacao,
                          isHidePaging: true,
                          "is-slot-mode": true,
                          onDoSearch: _cache[30] || (_cache[30] = (offset, limit, order, sort) => _ctx.doSearchSubTable(_ctx.registro.internacoes, order, sort))
                        }, null, 8, ["rows", "columns"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_tab, {
                      title: "Violência",
                      class: "mt-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_table_lite, {
                          style: {"font-size":".7rem"},
                          rows: _ctx.registro.violencias,
                          columns: _ctx.table.multiPageTableColumns.violencias,
                          isHidePaging: true,
                          "is-slot-mode": true,
                          onDoSearch: _cache[31] || (_cache[31] = (offset, limit, order, sort) => _ctx.doSearchSubTable(_ctx.registro.violencias, order, sort))
                        }, null, 8, ["rows", "columns"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_tab, {
                      title: "Acidente transporte",
                      class: "mt-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_table_lite, {
                          style: {"font-size":".7rem"},
                          rows: _ctx.registro.acidentesTransporte,
                          columns: _ctx.table.multiPageTableColumns.transporte,
                          isHidePaging: true,
                          "is-slot-mode": true,
                          onDoSearch: _cache[32] || (_cache[32] = (offset, limit, order, sort) => _ctx.doSearchSubTable(_ctx.registro.acidentesTransporte, order, sort))
                        }, null, 8, ["rows", "columns"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_tab, {
                      title: "Acidente trabalho",
                      class: "mt-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_table_lite, {
                          style: {"font-size":".7rem"},
                          rows: _ctx.registro.acidentesTrabalho,
                          columns: _ctx.table.multiPageTableColumns.trabalho,
                          isHidePaging: true,
                          "is-slot-mode": true,
                          onDoSearch: _cache[33] || (_cache[33] = (offset, limit, order, sort) => _ctx.doSearchSubTable(_ctx.registro.acidentesTrabalho, order, sort))
                        }, null, 8, ["rows", "columns"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_b_tab, {
                      title: "Intoxicação",
                      class: "mt-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_table_lite, {
                          style: {"font-size":".7rem"},
                          rows: _ctx.registro.intoxicacoes,
                          columns: _ctx.table.multiPageTableColumns.intoxicacoes,
                          isHidePaging: true,
                          "is-slot-mode": true,
                          onDoSearch: _cache[34] || (_cache[34] = (offset, limit, order, sort) => _ctx.doSearchSubTable(_ctx.registro.intoxicacoes, order, sort))
                        }, null, 8, ["rows", "columns"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("h5", _hoisted_53, "Agrupamento ML: " + _toDisplayString(_ctx.registro.agrupamentoML), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.registro.agrupamentoMLDesc), 1)
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-danger",
                    onClick: _cache[35] || (_cache[35] = $event => (_ctx.openModal({ modal: 'modalReclassify', title: 'Reclassificar', options: { agreeClassification: false } })))
                  }, _cache[79] || (_cache[79] = [
                    _createElementVNode("b", null, "Discordo", -1)
                  ])),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-warning text-white ml-1",
                    onClick: _cache[36] || (_cache[36] = $event => (_ctx.openModal({ modal: 'modalReclassify', title: 'Confirmar', options: { agreeClassification: true }  })))
                  }, _cache[80] || (_cache[80] = [
                    _createElementVNode("b", null, "Concordo", -1)
                  ])),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-success mt-1",
                    disabled: _ctx.registro.status !== 1,
                    onClick: _cache[37] || (_cache[37] = $event => (_ctx.openModal({
              modal: 'modalConfirm',
              title: 'Deseja realmente marcar como reclassificada no SIM?',
              action: () => _ctx.setReclassifiedSIM(),
            })))
                  }, _cache[81] || (_cache[81] = [
                    _createElementVNode("b", null, "Reclassificado no SIM", -1)
                  ]), 8, _hoisted_55)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.modalReclassify.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("h5", _hoisted_60, _toDisplayString(_ctx.modalReclassify.title), 1)
              ]),
              _createElementVNode("div", _hoisted_61, [
                _withDirectives(_createElementVNode("div", { class: "alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
                  [_vShow, _ctx.errorMessage != '']
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _cache[82] || (_cache[82] = _createElementVNode("label", {
                    for: "reclassification-select",
                    class: "mr-3"
                  }, "Reclassificação: ", -1)),
                  _createVNode(_component_model_select, {
                    options: _ctx.cidsToShow,
                    modelValue: _ctx.reclassificationInput,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => ((_ctx.reclassificationInput) = $event)),
                    filterPredicate: _ctx.myFilterPredicate
                  }, null, 8, ["options", "modelValue", "filterPredicate"])
                ]),
                _cache[83] || (_cache[83] = _createElementVNode("label", { for: "disagree-justification-text" }, "Justificativa: ", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  name: "disagree-justification-text",
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => ((_ctx.disagreeJustificationText) = $event)),
                  id: "disagree-justification-text",
                  class: "w-100 border rounded form-control",
                  style: {"resize":"none"}
                }, null, 512), [
                  [_vModelText, _ctx.disagreeJustificationText]
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-danger",
                  onClick: _cache[40] || (_cache[40] = $event => (_ctx.closeModal('modalReclassify')))
                }, _cache[84] || (_cache[84] = [
                  _createElementVNode("b", null, "Cancelar", -1)
                ])),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-success",
                  onClick: _cache[41] || (_cache[41] = $event => (_ctx.openReclassifyConfirmModal()))
                }, _cache[85] || (_cache[85] = [
                  _createElementVNode("b", null, "Confirmar", -1)
                ]))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.modalReclassifyConfirm.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("h5", _hoisted_68, _toDisplayString(_ctx.modalReclassifyConfirm.title), 1)
              ]),
              _createElementVNode("div", _hoisted_69, [
                _cache[86] || (_cache[86] = _createElementVNode("label", { style: {"float":"left"} }, "Reclassificação: ", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.reclassificationSelected) + " ", 1),
                _cache[87] || (_cache[87] = _createElementVNode("br", null, null, -1)),
                _cache[88] || (_cache[88] = _createElementVNode("br", null, null, -1)),
                _cache[89] || (_cache[89] = _createElementVNode("label", { style: {"float":"left"} }, "Justificativa: ", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.disagreeJustificationText), 1)
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-danger",
                  onClick: _cache[42] || (_cache[42] = $event => (_ctx.closeModal('modalReclassifyConfirm')))
                }, _cache[90] || (_cache[90] = [
                  _createElementVNode("b", null, "Cancelar", -1)
                ])),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-success",
                  onClick: _cache[43] || (_cache[43] = $event => (_ctx.reclassify()))
                }, _cache[91] || (_cache[91] = [
                  _createElementVNode("b", null, "Confirmar", -1)
                ]))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.modalConfirm.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("div", _hoisted_73, [
              _cache[94] || (_cache[94] = _createElementVNode("div", { class: "modal-header" }, null, -1)),
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("h5", _hoisted_75, _toDisplayString(_ctx.modalConfirm.title), 1)
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-danger",
                  onClick: _cache[44] || (_cache[44] = $event => (_ctx.modalConfirm.actionCancel ? _ctx.modalConfirm.actionCancel() : _ctx.closeModal('modalConfirm')))
                }, _cache[92] || (_cache[92] = [
                  _createElementVNode("b", null, "Cancelar", -1)
                ])),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-success",
                  onClick: _cache[45] || (_cache[45] = $event => (_ctx.modalConfirm.action()))
                }, _cache[93] || (_cache[93] = [
                  _createElementVNode("b", null, "Confirmar", -1)
                ]))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}